export { GenerarContrarecibosModalEdit } from "./generarcontrarecibos";
export { GenerarContrarecibosPPModalEdit } from "./generarcontrarecibospp";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/index.tsx